import { Check, X, Minus } from "lucide-react";
import Reveal from "../Reveal";

const ROWS = [
  { label: "Drag-and-drop scheduling & dispatch", fieldz: true, spreadsheet: false, legacy: true },
  { label: "Built-in business phone & two-way SMS", fieldz: true, spreadsheet: false, legacy: "Paid add-on" },
  { label: "Call masking for technicians", fieldz: true, spreadsheet: false, legacy: "Rarely included" },
  { label: "Technician mobile app with payments", fieldz: true, spreadsheet: false, legacy: "Varies" },
  { label: "Job-level profit & commission tracking", fieldz: true, spreadsheet: "Manual formulas", legacy: "Limited" },
  { label: "Online payments & e-signatures", fieldz: true, spreadsheet: false, legacy: "Paid add-on" },
  { label: "Multi-location dashboards", fieldz: true, spreadsheet: false, legacy: "Enterprise tier only" },
  { label: "Automated reminders & review requests", fieldz: true, spreadsheet: false, legacy: "Varies" },
];

const Cell = ({ v }) => {
  if (v === true) return <Check className="w-5 h-5 text-emerald-600 mx-auto" data-testid="compare-check" />;
  if (v === false) return <X className="w-5 h-5 text-slate-300 mx-auto" />;
  return (
    <span className="inline-flex items-center gap-1 text-[13px] text-slate-500 font-medium">
      <Minus className="w-3.5 h-3.5" /> {v}
    </span>
  );
};

const CompareTable = () => (
  <section id="compare" className="bg-white py-16 md:py-24" data-testid="compare-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl mb-12">
        <p className="text-xs uppercase tracking-[0.22em] font-semibold text-[var(--mk-blue)] mb-4">Why Fieldz AI</p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 leading-[1.2] mb-4">
          Fieldz AI vs spreadsheets vs legacy software
        </h2>
        <p className="text-lg text-slate-600 leading-relaxed">
          Purpose-built for field service — with the phone system, payments, and profit tracking most tools bolt on later.
        </p>
      </Reveal>

      <Reveal>
        <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-[0_10px_30px_-8px_rgba(15,23,42,0.08)]">
          <table className="w-full min-w-[640px] bg-white">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="text-left py-4 px-5 text-[13px] font-semibold text-slate-500 uppercase tracking-wider">Capability</th>
                <th className="py-4 px-4 text-center bg-[var(--mk-blue-light)]/50">
                  <span className="text-[15px] font-bold text-[var(--mk-blue)]">Fieldz AI</span>
                </th>
                <th className="py-4 px-4 text-center text-[14px] font-semibold text-slate-600">Spreadsheets & paper</th>
                <th className="py-4 px-4 text-center text-[14px] font-semibold text-slate-600">Legacy FSM software</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr key={r.label} className={`border-b border-slate-100 last:border-0 ${i % 2 === 1 ? "bg-slate-50/50" : ""}`}>
                  <td className="py-4 px-5 text-[14.5px] text-slate-700 font-medium">{r.label}</td>
                  <td className="py-4 px-4 text-center bg-[var(--mk-blue-light)]/30"><Cell v={r.fieldz} /></td>
                  <td className="py-4 px-4 text-center"><Cell v={r.spreadsheet} /></td>
                  <td className="py-4 px-4 text-center"><Cell v={r.legacy} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CompareTable;
